import { hasPermission } from '@/components/public'
// 做一个混入对象
export default {
  // 混入对象是组件的选项对象
  methods: {
    // 检查权限 要么有 没有没有 key就是要检查的点
    checkPermission(key) {
      return hasPermission(key)
    },
    openWithoutReferrer(url) {
      window.open('javascript:window.name;', '<script>location.replace("' + url + '")<' + '/' + 'script>')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/checkPermission.js